import { Feature } from '@turf/turf';

import { createOptimizedContext } from '@src/contexts/createOptimizedContext';

interface ExploreContext {
  geojson: Feature[] | null;
  markersList: Array<{ geometry: Feature['geometry'] }>;
}

export const {
  Provider: ExploreProvider,
  useStoreSelector: useExploreSelector,
  useStoreDispatch: useExploreDispatch
} = createOptimizedContext<ExploreContext>({
  geojson: null,
  markersList: []
});
